import { Box } from "@mui/material"
import { makeStyles } from "tss-react/mui-compat"
import InfiniteHorizontalScroller from "components/InfiniteHorizontalScroller"
import SmallVideoCard from "components/videos/SmallVideoCard"
import { useFavoriteVideosPages } from "hooks/useFavoriteVideosPages"
import React from "react"
import { createPath, ROUTE } from "app-constants/routing"

const useStyles = makeStyles()(
  (theme) => ({
    rootContainer: {
      width: "100%",
    },
    smallVideoCardContainer: {
      marginRight: theme.spacing(2),
      display: "flex",
      width: 280,
    },
  }),
)

interface FavoriteVideosProps {
  favoriteVideosPages: ReturnType<typeof useFavoriteVideosPages>
}

export const FavoriteVideos = (props: FavoriteVideosProps) => {
  const { favoriteVideosPages } = props
  const { classes } = useStyles()

  return (
    <Box className={classes.rootContainer}>
      <InfiniteHorizontalScroller
        title="From Your Favorite Exhibitors"
        emptyStateMessage="No videos found"
        hasMore={favoriteVideosPages.hasMore}
        loadMore={favoriteVideosPages.loadMore}
        loading={favoriteVideosPages.isValidating}>
        {favoriteVideosPages.videos.map((video) => (
          <Box className={classes.smallVideoCardContainer} key={video.id}>
            <SmallVideoCard
              href={createPath({path: ROUTE.VIDEO, params: {videoId: video.id}})}
              imageSrc={video.thumbnail_url ?? ""}
              imageAlt=""
              curatorName={video.institution?.name ?? ""}
              title={video.name}
              numberOfViews={video.video_count?.video_count ?? 0}
            />
          </Box>
        ))}
      </InfiniteHorizontalScroller>
    </Box>
  )
}
